import CheckBox from "components/chexkbox";
import { useTranslation } from "react-i18next";
import { useEffect, useRef } from "react";
import { checkBoxChange, modalControl } from "util/commAction";
import { useBookInfContext } from "components/context/bookInfContext";
import "./step3.scss";
import i18n from "locales/i18n";

type IModalInner = {
  inner: string;
  prvNm: string;
};

const ModalInner = ({ inner, prvNm }: IModalInner) => {
  const innerRef = useRef<HTMLElement | null>(null);

  useEffect(() => {
    if (innerRef.current) {
      innerRef.current.innerHTML = inner;
    }
  }, []);
  return (
    <>
      <h3 className="trm-ttl">{prvNm}</h3>
      <section ref={innerRef} className="term-cont" />
    </>
  );
};

export default function Terms() {
  const { terms, onCheckBox } = useBookInfContext();
  const { t } = useTranslation();
  const langCd = i18n.language;

  const termRef = useRef<HTMLDivElement>(null);

  const handleTermDetail = ({ inner, prvNm }: IModalInner) => {
    modalControl({
      isOpen: true,
      styles: "max-w-[90%] p-3 md:max-w-[700px] md:p-6",
      chckBtn: false,
      inner: (
        <>
          <ModalInner inner={inner} prvNm={prvNm} />
        </>
      ),
    });
  };

  return (
    <div className="consent-box" ref={termRef}>
      <h3 className="sub">{t("bck_ttl_chckbx_bk")}</h3>
      <form className="check-form">
        <div className="pt-6">
          <CheckBox
            label={t("chckbx_lbl_all_cmm")}
            name={""}
            id={"all"}
            styles="big"
            checked={terms?.all}
            onChange={(e) => {
              if (termRef.current) {
                checkBoxChange({
                  checked: e.currentTarget.checked,
                  parent: termRef.current,
                  type: "all",
                });
              }
              onCheckBox("all", e.currentTarget.checked);
            }}
          />
        </div>
        <ul className="pb-6">
          <li>
            <CheckBox
              label={t("chkbx_lbl_rqrd_cmm") + t("chckbx_term_01")}
              name={"term"}
              id={"01"}
              styles="border-0 "
              checked={terms["01"]}
              onChange={(e) => {
                if (termRef.current) {
                  checkBoxChange({
                    checked: e.currentTarget.checked,
                    parent: termRef.current,
                    type: "item",
                  });
                }
                onCheckBox("01", e.currentTarget.checked);
              }}
            />
            <span
              onClick={() =>
                handleTermDetail({
                  inner: langCd === "ko" ? U01 : U01EN,
                  prvNm: t("chckbx_term_01"),
                })
              }
            />
          </li>
          <li>
            <CheckBox
              label={t("chkbx_lbl_rqrd_cmm") + t("chckbx_term_02")}
              name={"term"}
              id={"02"}
              styles="border-0 "
              checked={terms["02"]}
              onChange={(e) => {
                if (termRef.current) {
                  checkBoxChange({
                    checked: e.currentTarget.checked,
                    parent: termRef.current,
                    type: "item",
                  });
                }
                onCheckBox("02", e.currentTarget.checked);
              }}
            />
            <span
              onClick={() =>
                handleTermDetail({
                  inner: langCd === "ko" ? U02 : U02EN,
                  prvNm: t("chckbx_term_02"),
                })
              }
            />
          </li>
          <li>
            <CheckBox
              label={t("chkbx_lbl_rqrd_cmm") + t("chckbx_term_03")}
              name={"term"}
              id={"03"}
              styles="border-0 "
              checked={terms["03"]}
              onChange={(e) => {
                if (termRef.current) {
                  checkBoxChange({
                    checked: e.currentTarget.checked,
                    parent: termRef.current,
                    type: "item",
                  });
                }
                onCheckBox("03", e.currentTarget.checked);
              }}
            />
            <span
              onClick={() =>
                handleTermDetail({
                  inner: langCd === "ko" ? U03 : U03EN,
                  prvNm: t("chckbx_term_03"),
                })
              }
            />
          </li>
          <li>
            <CheckBox
              label={t("chkbx_lbl_oot_cmm") + t("chckbx_term_04")}
              name={"term"}
              id={"04"}
              styles="border-0 "
              checked={terms["04"]}
              onChange={(e) => {
                if (termRef.current) {
                  checkBoxChange({
                    checked: e.currentTarget.checked,
                    parent: termRef.current,
                    type: "item",
                    essYn: false,
                  });
                }
                onCheckBox("04", e.currentTarget.checked);
              }}
            />
            <span
              onClick={() =>
                handleTermDetail({
                  inner: langCd === "ko" ? U04 : U04EN,
                  prvNm: t("chckbx_term_04"),
                })
              }
            />
          </li>
        </ul>
      </form>
    </div>
  );
}

const U04 = `
<section>
  <div class="trm-inner">
      <span>수신 동의한 이메일, SMS로 업로드부킹이 할인 쿠폰, 이벤트 등의 특별한 혜택 및 상품 정보를 받아 볼 수 있습니다.  수신 거부 시 사용 가능한 쿠폰 및 예약 알림 등이 발송되지 않습니다.</span>
      <table>
          <tbody>
              <tr>
                  <th>수집 및 이용 목적</th>
                  <td>
                      개인맞춤형 상품·서비스 혜택에 관한 정보제공, 통계·분석·이용내역 정보와의 결합 및 분석, 회사 또는 기타 광고주의 요청에 따른 정보·안내(프로모션·이벤트) 전송
                  </td>
              </tr>
              <tr>
                  <th>수집 항목</th>
                  <td>예약내역(예약일시, 결제금액, 업체명) 예약자 및 구매자 정보(이름,휴대폰번호,이메일), 상담 내용 및 상담에 필요한 개인정보<br/>
                      그 외 수집하는 정보가 있으면 추가 할 것
                  </td>
              </tr>
              <tr>
                  <th>보유 및 이용 기간</th>
                  <td>
                      •회원 탈퇴 또는 동의 철회 요청 시 까지<br/>
                      •동의 철회 또는 이용종료일부터 *개월후 파기.
                  </td>
              </tr>
          </tbody>
      </table>
      <table>
          <tbody>
              <tr>
                  <th>전송자</th>
                  <td>주식회사 유비컴퍼니</td>
              </tr>
              <tr>
                  <th>전송자 연락처</th>
                  <td>museum@uploadbooking.com</td>
              </tr>
              <tr>
                  <th>파기 절차 및 방법</th>
                  <td>파기절차:회사는 파기 사유가 발생한 개인정보를 선정하고 개인 정보 보호책임자 승인 후 개인정보를 파기함.<br/>
                      파기방법:회사는 전자적 파일 형태로 처리된 정보는 기록을 재생 할 수 없도록 파기하며,종이 문서에 의하여 처리된 개인정보는 분쇄기로 분쇄하거나 소각하여 파기함.
                  </td>
              </tr>
          </tbody>
      </table>
      <span>동의한 개인 정보는 업로드부킹(uploadbooking.com)에서 새로운 서비스 및 이벤트 정보 등의 안내를 하기 위해 업로드부킹 관리자 데이터 베이스에 수집되고있으며, 제3자는 광고성 정보를 보낼 수 없습니다.</span>
  </div>
</section>`;

const U04EN = `
  <section>
    <div class="trm-inner">
        <span>By consenting to receive emails and SMS, you will get special offers, discount coupons, and event information from UploadBooking. If you opt out, you will not receive usable coupons or reservation alerts.</span>
        <table>
            <tbody>
                <tr>
                    <th>Purpose of Collection and Use</th>
                    <td>
                        Providing personalized product and service benefits, combining and analyzing usage data and statistics, and sending information or promotions at the request of the company or advertisers.
                    </td>
                </tr>
                <tr>
                    <th>Collected Information</th>
                    <td>Reservation details (date, payment amount, company name), guest and purchaser information (name, phone number, email), consultation details and necessary personal information.<br/>
                        Additional information may be collected if applicable.
                    </td>
                </tr>
                <tr>
                    <th>Retention and Use Period</th>
                    <td>
                        • Until membership withdrawal or consent withdrawal.<br/>
                        • Personal data will be destroyed * months after consent withdrawal or service termination.
                    </td>
                </tr>
            </tbody>
        </table>
        <table>
            <tbody>
                <tr>
                    <th>Sender</th>
                    <td>Ubicompany Inc.</td>
                </tr>
                <tr>
                    <th>Sender Contact</th>
                    <td>museum@uploadbooking.com</td>
                </tr>
                <tr>
                    <th>Destruction Procedure and Method</th>
                    <td>
                        Procedure: The company selects personal information to be destroyed and destroys it after approval from the Personal Information Protection Officer.<br/>
                        Method: Electronic files are destroyed so that data cannot be recovered, and paper documents are shredded or incinerated.
                    </td>
                </tr>
            </tbody>
        </table>
        <span>The personal information you provide is collected in UploadBooking's database to inform you about new services and events. Third parties are not permitted to send promotional information.</span>
    </div>
</section>
`;

const U03 = `
<section>
  <div class="trm-inner">
      <table>
          <tbody>
              <tr>
                  <td>제공 받는자</td>
                  <td>정보 제공 항목</td>
                  <td>제공 목적</td>
                  <td>보유 및 이용기간</td>
              </tr>
              <tr>
                  <td>예약숙소</td>
                  <td>
                      예약 및 숙박 서비스 이용자의 정보 <br/>
                      (예약자명, 투숙자명, 이메일, 핸드폰번호, 예약번호, 결제정보 (결제금액, 신용카드번호, 유효기간)) 
                  </td>
                  <td>숙박 예약 서비스의 이용 계약 이행(서비스 제공,예약 확인,이용자 정보 확인)</td>
                  <td>5년</td>
              </tr>
              <tr>
                  <td>예약확인서 발송업체 </td>
                  <td>거래정보(투숙자명, 이메일, 휴대폰번호, 예약번호, 결제정보(결제금액))</td>
                  <td>예약관련 안내사항의 이메일 예약확인서 발송</td>
                  <td>5년</td>
              </tr>
              <tr>
                  <td>알림톡 발송업체</td>
                  <td>거래정보 (성명, 휴대폰번호, 상품명, 상품금액, 예약내용)</td>
                  <td>예약관련 안내사항의 카카오 알림톡, SMS전송</td>
                  <td>5년</td>
              </tr>
              <tr>
                  <td>결제 대행 업체</td>
                  <td>결제정보 (구매자명, 상품명)</td>
                  <td>결제관련 결제사항의 이메일 또는 문자 발송</td>
                  <td>5년</td>
              </tr>
          </tbody>
      </table>
      <span>
          <span class="font-red">※</span> 더 나은 서비스를 위하여 고객님의 개인정보를 협력 업체 등과 공유할 필요가 있는 경우에는 해당 내용을 이용자에게 고지하여 동의를 구합니다.
      </span>
      <h5>[개인정보의 제3자 제공 거부]</h5>
      <span>이용자는 개인정보의 제3자 제공 동의를 거부할 수 있습니다.단,동의를 거부하는 경우 본 서비스 결제 및 예약이 정상적으로 이루어 질 수 없음을 알려드립니다.</span>
  </div>
</section>
`;

const U03EN = `
<section>
    <div class="trm-inner">
        <table>
            <tbody>
                <tr>
                    <td>Recipient</td>
                    <td>Information Provided</td>
                    <td>Purpose of Provision</td>
                    <td>Retention Period</td>
                </tr>
                <tr>
                    <td>Reserved Accommodation</td>
                    <td>
                        User information for reservation and stay<br/>
                        (Reservation name, guest name, email, phone number, reservation number, payment details (amount, credit card number, expiration date))
                    </td>
                    <td>To fulfill the accommodation reservation service contract (service provision, reservation confirmation, user information verification)</td>
                    <td>5 years</td>
                </tr>
                <tr>
                    <td>Reservation Confirmation Sender</td>
                    <td>Transaction information (guest name, email, phone number, reservation number, payment details (amount))</td>
                    <td>Sending reservation confirmation emails related to reservation details</td>
                    <td>5 years</td>
                </tr>
                <tr>
                    <td>Notification Message Provider</td>
                    <td>Transaction information (name, phone number, product name, product amount, reservation details)</td>
                    <td>Sending KakaoTalk notifications and SMS about reservation details</td>
`;

const U02 = `
<section>
  <div class="trm-inner">
      <table>
          <tbody>
              <tr>
                  <th>수집 및 이용    목적</th>
                  <td>서비스 가입, 계약의 이행 및 서비스 제공, 예약·구매 내역, 고지·안내사항 전달, 상담·불만·민원처리, 상품·서비스 이용 실적 정보 통계·분석, 상품·서비스 개선 및 추천, 불법·부정 이용 방지</td>
              </tr>
              <tr>
                  <th>수집 항목</th>
                  <td>
                      서비스 이용시 <br/>
                      · 이메일(ID),비밀번호,설명,휴대폰 번호<br/>
                      예약·구매 시 <br/>
                      ·공통 , 예약 내역(예약일시, 결제금액, 업체명)<br/>
                      ·예약자 및 구매자 - 성명, 휴대폰 번호, 이메일 주소<br/>
                      상담 문의시<br/>
                      · 상담내용 및 상담에 필요한 개인 정보<br/>

                  </td>
              </tr>
              <tr>
                  <th>보유 및 이용 기간</th>
                  <td>
                  •이용 종료일로부터 상담 등 민원처리를 위해 30일 후 삭제<br/>

                  •회원 탈퇴 요청시 상담등 민원 처리를 위해 30일 후 삭제<br/>
                  (단, 법렵상 의무를 준수하기 위하여 필요한 경우 법령이 정한 기간까지)<br/>
                  </td>
                  </td>
              </tr>
          </tbody>
      </table>
      <strong>1. 예약 및 결제 서비스 제공 </strong>
      <span>
          본 예약 서비스는 주식회사 유비컴퍼니(이하 '회사'라 합니다)이 제공하는 UPLOADBOOKING 시스템에서 제공받고 있습니다. 회사가 제공하는 전자상거래 서비스 이용과 관련하여, 서비스 이용을 위한 본인 확인, 예약 및 결제, 예약 취소 및 노쇼 시 대금 지급 요청, 서비스 부정 이용 방지, 각종 불편 사항 접수 및 분쟁 조정을 위해 필요한 이용자의 최소한의 개인정보를 수집합니다. 서비스 이용과정에서 해당 서비스의 이용자에 한해 추가 개인정보 수집이 발생할 수 있습니다. 추가로 개인정보를 수집할 경우에는 해당 개인정보 수집 시점에서 이용자에게 ‘수집하는 개인정보 항목, 개인정보의 수집 및 이용목적, 개인정보의 보관기간’에 대해 안내 드리고 동의를 받습니다.
      </span>
      <strong>2. 서비스 개선, 신규 서비스 개발 및 마케팅, 서비스 이용 통계 및 설문</strong>
      <span>
          서비스 개선, 신규 서비스 개발, 개인 맞춤서비스, 서비스 마케팅 활용을 위해 수집된 개인정보가 활용될 수 있습니다. 또한 통계적 정보를 바탕으로 서비스 유효성 확인, 광고 게재, 이벤트 정보 및 참여기회 제공, 회원의 서비스 이용에 대한 통계제작을 목적으로 개인정보가 활용될 수 있습니다.
      </span>
      <h5>[개인정보의수집항목]</h5>
      <strong>1. 예약, 결제 서비스 이용 시 </strong>
      <span>
          ㆍ(공통) 이용자 식별 정보 - 이름, 이메일주소, 연락처(휴대폰번호) (단, 예약자와 방문자가 다를 경우 방문자의 이름, 연락처, 이메일)<br/>
          ㆍ(예약 및 결제 보증 시) – 예약 비밀번호, 신용카드번호(유효기간 포함)
      </span>
      <strong>2. 자동수집 항목 및 수집방법</strong>
      <span>
          수집항목 : 서비스 이용 과정에서 IP 주소, 쿠키, 방문일시 등의 서비스 이용 기록, 기기정보(모델명, OS버전, 디바이스 ID, IMEI 등)<br/>
          수집방법 : 서비스 이용 과정에서 이용자에 관한 정보를 정보통신서비스 제공자가 자동화된 방법으로 생성하여 이를 저장(수집)
      </span>
      <h5>[개인정보의보유 및 이용기간]</h5>
      <span>
          회사는 원칙적으로 이용자의 개인정보를 회원 탈퇴 시 지체없이 파기하고 있습니다.
          단, 이용자에게 개인정보 보관기간에 대해 별도의 동의를 얻은 경우, 또는 법령에서 일정 기간 정보보관 의무를 부과하는 경우에는 해당 기간 동안 개인정보를 안전하게 보관합니다.
      </span>
      <table>
          <tbody>
              <tr>
                  <td>근거법률</td>
                    <td>목적</td>
                    <td>수집항목</td>
                    <td>보유기간</td>
              </tr>
              <tr>
                  <td>개인정보보호법</td>
                  <td>통계·학술·연구목적</td>
                  <td>비식별화, 익명화작업을 거친 정보</td>
                  <td>준영구</td>
              </tr>
              <tr>
                  <td>통신비밀보호법</td>
                  <td>법원의영장을 받아 수사기관이 요청 시 제공</td>
                  <td>IP등로그기록</td>
                  <td>3개월</td>
              </tr>
              <tr>
                  <td rowspan="3">전자상거래등에서의 소비자보호에 관한법률</td>
                  <td>소비자의 불만 또는 분쟁처리에 관한 기록확인</td>
                  <td>이용자식별정보, 분쟁처리기록등</td>
                  <td>3년</td>
              </tr>
              <tr>
                  <td >대금결제 및 재화등의 공급에 관한 기록확인</td>
                  <td rowspan="2">이용자식별정보, 계약/청약 철회기록 등</td>
                  <td rowspan="2">5년</td>
              </tr>
              <tr>
                  <td>계약 또는 청약철회 등에 관한 기록확인</td>
              </tr>
          </tbody>
      </table>
      <span>회원의 경우 ‘개인정보 유효기간제’에 따라 1년간 서비스를 이용하지 않은 회원의 개인정보를 별도로 분리 보관하여 관리하고 있습니다.</span>
      <h5> [개인정보 수집 동의 거부의 권리] </h5>
      <span>
          1. 귀하는 위 개인정보의 수집이용에 대한 동의를 거부할 수 있으며, 동의 후에도 언제든지 철회할 수 있습니다.<br/>
          2. 위 개인정보의 수집이용에 동의하지 않을 경우, 본 서비스 결제 및 예약이 정상적으로 이루어질 수 없음을 알려드립니다.<br/>
      </span>
  </div>
</section>`;

const U02EN = `
<section>
    <div class="trm-inner">
        <table>
            <tbody>
                <tr>
                    <th>Purpose of Collection and Use</th>
                    <td>
                        Service registration, contract fulfillment and service provision, reservation and purchase records, delivery of notices and announcements, consultation, complaints and dispute resolution, statistical analysis of usage data, service improvement and recommendations, prevention of illegal or fraudulent use
                    </td>
                </tr>
                <tr>
                    <th>Items Collected</th>
                    <td>
                        When using the service:<br/>
                        · Email (ID), password, description, mobile phone number<br/>
                        At reservation or purchase:<br/>
                        · Common: reservation details (date and time, payment amount, company name)<br/>
                        · Reservation and purchaser information: name, mobile number, email address<br/>
                        During inquiries:<br/>
                        · Inquiry content and necessary personal information for consultation
                    </td>
                </tr>
                <tr>
                    <th>Retention and Usage Period</th>
                    <td>
                        • Data will be deleted 30 days after service termination for consultation or dispute resolution purposes.<br/>
                        • Upon membership withdrawal request, data will be deleted 30 days later for consultation and dispute resolution.<br/>
                        (However, if required by law, data will be retained for the legally mandated period.)
                    </td>
                </tr>
            </tbody>
        </table>
        <strong>1. Provision of Reservation and Payment Services</strong>
        <span>
            This reservation service is provided by UploadBooking system operated by Ubicompany Co., Ltd. (“the Company”). To use the e-commerce services offered, we collect the minimum personal information necessary for identity verification, reservation and payment processing, cancellation and no-show payment requests, prevention of fraudulent use, handling complaints, and dispute resolution. Additional personal information may be collected during service use for specific purposes, and users will be notified and asked for consent regarding the types of data collected, purposes, and retention periods at that time.
        </span>
        <strong>2. Service Improvement, New Service Development, Marketing, and Usage Statistics</strong>
        <span>
            Collected personal information may be used to improve services, develop new services, provide personalized services, and for marketing purposes. Additionally, data may be utilized for validating service effectiveness, placing advertisements, providing event information and participation opportunities, and generating usage statistics.
        </span>
        <h5>[Personal Information Collected]</h5>
        <strong>1. When Using Reservation and Payment Services</strong>
        <span>
            · (Common) User identification information – name, email address, contact number (mobile). If the reservation name differs from the visitor, visitor’s name, contact, and email are collected.<br/>
            · (For reservation and payment guarantees) – reservation password, credit card number (including expiration date)
        </span>
        <strong>2. Automatically Collected Items and Collection Methods</strong>
        <span>
            Collected items: IP address, cookies, visit date/time, service usage records, device information (model, OS version, device ID, IMEI, etc.)<br/>
            Collection method: Automatically generated and stored by the information and communication service provider during service use
        </span>
        <h5>[Retention and Use Period of Personal Information]</h5>
        <span>
            In principle, the Company destroys personal information without delay upon membership withdrawal. However, if separate consent for retention is obtained or if laws require certain retention periods, personal data will be securely stored during those periods.
        </span>
        <table>
            <tbody>
                <tr>
                    <td>Applicable Law</td>
                    <td>Purpose</td>
                    <td>Collected Data</td>
                    <td>Retention Period</td>
                </tr>
                <tr>
                    <td>Personal Information Protection Act</td>
                    <td>Statistics, Academic, Research Purposes</td>
                    <td>De-identified or anonymized information</td>
                    <td>Indefinite</td>
                </tr>
                <tr>
                    <td>Communication Privacy Protection Act</td>
                    <td>Provision upon court order to investigative agencies</td>
                    <td>IP and log records</td>
                    <td>3 months</td>
                </tr>
                <tr>
                    <td rowspan="3">Consumer Protection in Electronic Commerce Act</td>
                    <td>Record verification for complaints or dispute resolution</td>
                    <td>User identification data, dispute records</td>
                    <td>3 years</td>
                </tr>
                <tr>
                    <td>Verification of payment and supply records</td>
                    <td rowspan="2">User identification data, contract/cancellation records</td>
                    <td rowspan="2">5 years</td>
                </tr>
                <tr>
                    <td>Verification of contract or cancellation records</td>
                </tr>
            </tbody>
        </table>
        <span>
            For members, personal data of those inactive for one year are separately stored and managed according to the “Personal Information Validity Period System.”
        </span>
        <h5>[Right to Refuse Consent to Personal Information Collection]</h5>
        <span>
            1. You may refuse to consent to the collection and use of personal information at any time, even after consenting.<br/>
            2. Please note that refusal may prevent proper processing of payments and reservations for this service.
        </span>
    </div>
</section>

`;

const U01 = `
<section>
<h5>[제 1 장 총칙]</h5>
<div class="trm-inner">
  <strong>제 1 조 (목적)</strong>
  <span>
    이 약관은 주식회사 유비컴퍼니(이하 '회사'라 합니다)가 제공하는 전자상거래 관련 서비스의 이용과 관련하여 회사와 이용자(개인 또는 법인) 간의 권리, 의무 및 책임사항, 이용조건 및 절차 기타 필요한 사항을 규정함을 목적으로 합니다. 이 약관은 회사가 제공하는 전자상거래 관련 서비스 일체에 적용됩니다.
  </span>
  <strong>제 2 조 (용어의 정의)</strong>
  <span>
    <p>이 약관에서 사용하는 용어의 정의는 다음 각 호와 같습니다.</p>

    “서비스”라 함은 회사가 전자적 방법으로 제공하는 숙박중개 등 일체의 용역을 의미하며, 회사가 공개한 API(Application Programming Interface)를 이용하여 제 3자가 개발 또는 구축한 정보통신매체를 통하여 이용자에게 제공되는 용역을 포함합니다.
    “이용자”라 함은 회사가 제공하는 서비스를 이용하는 회원 또는 비회원을 말합니다.
    “회원”이라 함은 이 약관에 따라 회사와 이용 계약을 체결하고, 회사가 제공하는 서비스를 이용하는 사람을 말합니다.
    “비회원”이라 함은 이 약관에 따른 회원계약을 체결하지 않고 회사가 제공하는 서비스를 이용하는 사람을 말합니다. 
    “가입신청인”이라 함은 이 약관에 의하여 회원이 되고자 하는 사람을 말합니다.
    “회원계약”이라 함은 회사와 가입신청인 간에 체결되는 회원가입계약을 말하고, “구매계약”이라 함은 회사와 이용자 간에 체결되는 재화 또는 용역의 매매계약을 말합니다. 
    “비밀번호(Password)”라 함은 회원의 본인 신원 확인을 위하여 회원이 설정하여 회사에 등록한 고유의 문자와 숫자의 조합을 말합니다. 
    “할인쿠폰”이라 함은 "티켓" 또는 "상품 등"을 구매할 때 증권 상 표기된 액면가액만큼 할인 받을 수 있는 디지털 증권을 말합니다.
    “판매자”라 함은 회사가 제공하는 서비스를 이용하여 이용자에게 재화·용역 등에 관한 정보를 전달하고 그 재화·용역을 판매하는 사업자(개인 또는 법인)를 의미합니다.

  </span>

  <strong>제 3 조 (약관의 명시와 설명 및 개정) </strong>
  <span>
    회사는 이 약관의 내용과 상호 및 대표자 성명, 영업소 소재지 주소, 전화번호, 전자우편주소, 사업자등록번호 등과 함께 회사 홈페이지(서비스 초기화면)에 게시합니다. 다만, 이 약관의 내용은 이용자가 연결화면을 통하여 볼 수 있도록 할 수 있습니다. 
    회사는 전자상거래 등에서의 소비자보호에 관한 법률, 약관의 규제에 관한 법률, 전자문서 및 전자거래 기본법, 전자금융거래법, 전자서명법, 정보통신망 이용촉진 및 정보보호 등에 관한 법률, 소비자기본법 등 관련 법령을 위배하지 않는 범위에서 이 약관을 개정할 수 있습니다. 
    회사가 약관을 개정할 경우에는 적용일자 및 개정사유를 명시하여 현행 약관과 함께 회사 홈페이지(서비스 초기화면)에 그 개정약관의 적용일자 7일 전부터 적용일자 전일까지 공지합니다. 다만, 이용자에게 불리하게 약관내용을 개정하는 경우, 회사는 개정약관 적용일자 30일 이전 서비스 초기화면 공지 외에 서면(전자문서 또는 전자우편을 포함), 서비스 접속 시의 팝업창 등의 전자적 수단을 통해 명확히 통지합니다.
    회사가 약관을 개정할 경우 그 개정약관은 관련 법령 또는 기타 부득이한 사유가 존재하지 아니하는 이상 그 적용일자 이후에 체결되는 계약에만 적용되고 그 이전에 이미 체결된 계약에 대하여서는 개정 전의 약관조항이 그대로 적용됩니다.
    회사가 개정약관을 공지 또는 통지하면서 회원에게 해당 기간 내에 의사표시를 하지 않으면 의사표시가 표명된다는 것으로 본다는 뜻을 명확하게 고지 또는 통지하였음에도 회원이 명시적으로 거부의사표시를 하지 아니한 경우에는 회원이 개정약관에 동의한 것으로 봅니다. 회원이 개정약관에 동의하지 아니하는 경우 언제든지 자유롭게 회원계약을 해지할 수 있습니다. 
    이 약관 또는 개별약관에서 정하지 않은 사항과 이 약관의 해석에 관하여서는 전자상거래 등에서의 소비자보호에 관한 법률, 약관의 규제에 관한 법률 등 관계법령 또는 상관례에 따릅니다.  

  </span>
  <strong>제 4 조 (이용자에 대한 통지) </strong>
  <span>
    회사가 이용자에 대한 통지를 하는 경우 이 약관에 별도 규정이 없는 한 서면(전자문서 또는 전자우편을 포함)에 의하여 이용자가 회사에 제공한 전자우편주소, 전화번호, 주소 등에 합니다.
    회사는 이용자 전체에 대한 통지의 경우 7일 이상 회사의 공지사항(고객센터)에 게시함으로써 제1항의 통지에 갈음할 수 있습니다.  다만 이용자의 서비스 이용과 관련하여 중대한 영향을 미치는 사항에 대하여는 개별통지를 합니다.

  </span>
</div>
</section>
<section>
<h5>[제 2 장 회원계약의 성립과 소멸]</h5>
<div class="trm-inner">
  <strong>제 5 조 (회원계약의 체결) </strong>
  <span>
    회원계약은 가입신청인이 이 약관의 내용에 대하여 동의를 한 다음 회원가입신청을 하고 회사가 이러한 가입신청에 대하여 승낙함으로써 체결됩니다. 다만, 가입신청인(이용자가 14세 미만의 아동인 경우 그 아동의 법정대리인)이 가입신청 당시 이 약관의 내용과 함께 제공한 동의 확인란에 동의를 표시한 경우, 회사는 이용자가 이 약관의 내용을 모두 읽고 이를 충분히 이해하였으며, 이를 적용하는 것에 동의한 것으로 간주합니다.
    회사는 제1항의 가입신청과 관련하여 가입신청인에게 전문기관을 통한 실명확인 및 본인인증을 요청할 수 있습니다.
    가입신청인은 회사의 요청에 따라 본인의 개인 정보 중 필수항목(성명, 생년월일, 성별, 전자우편주소, 비밀번호, 전화번호, 주소 등)을 제공하여야 합니다.
    회사는 가입신청자의 서비스 이용 신청에 대하여 승낙함을 원칙으로 합니다. 다만 회사는 다음 각 호에 해당하는 신청에 대하여는 승낙을 하지 않거나 사후에 회원계약을 해지할 수 있습니다. 
    실명이 아니거나 타인의 명의를 사용한 경우
    가입신청인이 회원가입 신청일 이전에 이 약관에 의하여 회원자격을 상실한 적이 있는 경우 단, 회사의 회원 재가입 승낙을 얻은 경우에는 예외로 함
    허위의 정보를 기재하거나 회사가 제시한 필수항목을 기재하지 않는 경우
    19세 미만 청소년이 법정대리인의 동의를 얻지 아니한 경우
    이용자가 회원탈퇴 후 30일 이내 재가입을 신청하거나 부정한 용도 또는 영리 추구를 목적으로 서비스를 이용하는 경우
    관계법령에 위배되거나 선량한 풍속 기타 사회질서를 저해할 수 있는 목적으로 신청한 경우
    기타 이용자의 귀책사유로 인하여 승인이 불가능하거나 기타 제반 사항을 위반하여 신청한 경우
    회사는 서비스 관련 설비의 여유가 없거나, 기술상 또는 업무상 문제가 있는 경우에는 승낙을 유보할 수 있습니다. 
    제4항 또는 제5항에 따라 회원가입신청의 승낙을 하지 아니하거나 유보한 경우, 회사는 원칙적으로 가입신청인에게 그 사실을 알리도록 합니다.

    <p>
      회원계약의 체결시기는 회사가 가입신청인에게 회원계약 승낙사실(회원가입)을 표시한 시점으로 합니다.
    </p>
  </span>
  <strong>제 6 조 (회원계약의 해지) </strong>
  <span>
    회원은 언제든지 회사에게 회원계약 해지를 신청할 수 있고, 회사는 관련 법령 등이 정하는 바에 따라 3영업일 이내에 이를 처리합니다.
    회사는 회원에게 회원계약 위반 등 다음 각 호의 사유가 발생한 경우 2주 이상의 기간을 정하여 서면(전자문서 또는 전자우편을 포함)으로 회원계약의 위반의 시정을 최고할 수 있고, 회원이 그 기간 내에 회원계약 위반을 시정하지 아니할 경우, 회사는 회원에게 해지의 의사를 표시함으로써 회원계약을 해지할 수 있습니다. 다만, 회원에게 회원계약 상의 권리 행사 또는 의무의 이행을 계속할 수 없는 사유가 발생한 경우 회사는 최고 없이 회원계약을 해지할 수 있습니다.
    회원계약 체결을 전후로 회원에게 제5조 제4항의 사유가 발생한 경우
    회원이 서비스와 관련하여 회사 또는 제3자에게 직·간접적으로 재산적·비재산적 손해를 가한 경우
    회원이 회사 또는 타인의 권리나 명예, 신용 기타 정당한 이익을 침해하여 회사의 영업을 침해한 경우
    회원이 이 약관에 위배되는 행위를 하거나 이 약관에서 정한 해지사유가 발생한 경우
    회사 또는 회원이 회원계약을 해지하는 경우, 회사는 해지의 의사를 통지하거나 통지받은 때로부터 3영업일 이내에 회원탈퇴에 관한 업무를 처리합니다.
    회사 또는 회원이 회원계약을 해지하는 경우, 관련법 및 개인정보 처리 방침에 따라 회사가 회원정보를 보유하는 경우를 제외하고는 해지업무 처리 완료 즉시 회원의 데이터는 아래와 같은 절차와 방법에 따라 파기처리 됩니다.
    파기절차: 회사는 파기 사유가 발생한 개인정보를 선정하고, 개인정보 보호책임자의 승인 후 개인정보를 파기합니다.
    파기방법: 회사는 전자적 파일 형태로 처리된 정보는 기록을 재생할 수 없도록 파기하며, 종이 문서에 의하여 처리된 개인정보는 분쇄기로 분쇄하거나 소각하여 파기합니다
    회사 또는 회원이 회원계약을 해지하는 경우, 회원의 보유한 할인 쿠폰은 탈퇴와 즉시 소멸되며 회원은 쿠폰의 소멸로 인하여 발생하는 경제적 이익의 상실에 관하여 회사에게 손해배상 등 법적 청구를 할 수 없습니다.
    회원계약의 해지시기는 회사가 회원에게 회원계약 해지사실(회원탈퇴)을 표시한 때로 합니다.  

  </span>
</div>
</section>
<section>
<h5>[제 3 장 서비스의 이용]</h5>
<div class="trm-inner">
  <strong>제 7 조 (서비스의 제공 및 변경) </strong>
  <span>
    회사는 회원에게 아래와 같은 서비스를 제공합니다. 
    숙박시설, 음식점, 기타 장소에 관한 정보 제공 서비스
    숙박시설 및 음식점 예약 서비스
    기타 회사가 추가 개발하거나 다른 회사와의 제휴계약 등을 통해 제공하는 서비스
    회사는 이용 감소로 인한 원활한 서비스 제공의 곤란 및 수익성 악화, 서비스 제공과 관련한 회사 정책의 변경 등 기타 상당한 이유가 있는 경우에 운영상, 기술상의 필요에 따라 제공하고 있는 전부 또는 일부 서비스를 변경 또는 중단할 수 있습니다. 
    회사는 서비스의 변경 또는 서비스 중단이 예정된 경우 예정일로부터 30일 이상의 기간 전 WCRS홈페이지(서비스 초기화면)에 변경 또는 중단될 서비스의 종류, 변경 또는 중단 내용과 사유, 변경 또는 중단 일시 등을 공지합니다. 
    회사는 이용자에게 무료로 제공하는 서비스의 일부 또는 전부를 회사의 경영상 필요에 의하여 변경, 중단, 폐지할 수 있으며, 이에 대하여 관련법에 특별한 규정이 없는 한 이용자에게 별도의 보상을 하지 않습니다. 

    않습니다.
  </span>
  <strong>제 8 조 (서비스 및 고객센터 이용시간) </strong>
  <span>
    서비스는 주중 (공휴일 제외) 9시~18시까지 제공함을 원칙으로 합니다
    회사는 컴퓨터 등 정보통신설비의 보수점검, 교체 및 고장, 통신두절 또는 운영상 상당한 이유가 있는 경우 서비스의 제공을 일시적으로 중단할 수 있습니다. 이 경우 회사는 제4조(이용자에 대한 통지)에 정한 방법으로 회원에게 통지합니다. 다만, 회사가 사전에 통지할 수 없는 부득이한 사유가 있는 경우 사후에 통지할 수 있습니다.
    회사는 서비스의 제공에 필요한 경우 정기점검을 실시할 수 있으며, 정기점검시간은 회사 홈페이지(서비스 초기화면)에 공지한 바에 따릅니다.

  </span>
  <strong>제 9 조 (정보의 제공 및 광고의 게재)</strong>
  <span>
    회사는 회원의 서비스 이용에 필요하다고 인정되는 정보를 공지사항 또는 서면(전자문서 또는 전자우편을 포함), 문자메시지(SMS), 전화, 애플리케이션 푸쉬(Push) 등의 방법으로 회원에게 제공할 수 있습니다. 다만, 회원은 관련법에 따른 거래관련정보 및 고객문의 등에 대한 답변 등을 제외하고는 언제든지 위 정보의 제공수신을 거절할 수 있습니다.
    회사는 서비스의 운영과 관련하여 회사 홈페이지(서비스 초기화면), 전자우편, SMS, 앱 푸쉬(App Push) 등에 광고를 게재할 수 있습니다. 다만, 전자우편, SMS, 앱 푸쉬 등 전자적 전송매체의 경우 정보통신망법에서 정한 바에 따라 원칙적으로 회사는 수신자의 명시적인 사전동의를 받아야 하고, 수신자가 수신거부의사를 표시하거나 사전 동의를 철회한 경우에는 영리목적의 광고성 정보를 전송하지 않습니다. 광고가 게재된 전자우편을 수신한 회원은 수신거절을 회사에게 할 수 있습니다.
    
  </span>
  <strong>제 10 조 (서비스 이용과 지식재산권) </strong>
  <span>
    회사가 서비스 제공과 관련하여 작성· 편집한 저작물(2차 저작물을 포함, 이하 동일)에 대한 지식재산권은 회사에 귀속되며, 이용자는 서비스 이용 과정에서 얻은 회사의 저작물을 회사의 명시적인 사전 승낙 없이 복제, 송신, 출판, 배포, 방송 등 기타 방법에 의하여 이용하거나 제3자에게 이용하게 하여서는 안됩니다.
    회원이 서비스를 이용하여 서비스 상에 부호, 문자, 음성, 음향, 화상, 동영상 등의 정보형태의 글, 사진, 동영상 및 각종 파일과 링크 등을 게시한 “게시물＂의 저작권은 회원에게 귀속됩니다.
    회원 가입을 하여 윙스 부킹 서비스를 이용 하는 경우 회사는 회원의 게시물을 회원 서비스 화면에 표시할 수 있습니다. 이 경우, 회사는 저작권법 규정을 준수하며, 회원은 언제든지 고객센터 또는 어플리케이션 내 관리 기능을 통해 해당 게시물에 대해 삭제, 비공개 등의 조치를 취할 수 있습니다.
    회사는 전항에 따른 권리자의 요청이 없는 경우라도 권리 침해가 인정될 만한 사유가 있거나 기타 회사 정책 및 관련법에 위반되는 경우에는 관련법에 따라 해당 게시물에 대해 임시 조치 등을 취할 수 있습니다.
    회사는 바람직한 게시판 문화를 활성화하기 위하여 동의 없는 타인의 신상 공개 시 특정부분을 삭제하거나 기호 등으로 수정하여 게시할 수 있습니다.
    게시물에 관련된 제반 권리와 책임은 작성자 개인에게 있습니다. 또 게시물을 통해 자발적으로 공개된 정보는 보호받기 어려우므로 정보 공개전에 심사숙고 하시기 바랍니다.
    가입 해지 시 고객께서 작성하신 게시물은 자동으로 파기됩니다.
    
  </span>
  <strong>제 11 조 (게시물의 관리)</strong>
  <span>
    회원의 게시물이 정보통신망 이용촉진 및 정보보호 등에 관한 법률 및 저작권법 등 관련법에 위반되는 내용을 포함함으로 인하여, 지식재산권 등의 권리를 보유한 자가 회사에게 관련법이 정한 절차에 따라 해당 게시물의 게시중단 또는 삭제 등을 요청하는 경우, 회사는 관련법에 따라 조치를 취합니다.
    회사는 전항에 따른 권리자의 요청이 없는 경우라도 회사 또는 제3자의 권리침해가 인정될 만한 사유가 있거나 기타 회사 정책 및 관련법에 위반되는 경우에는 관련법에 따라 해당 게시물에 대해 임시조치 등을 취할 수 있습니다.

  </span>
  <strong>제 12 조 (할인쿠폰) </strong>
  <span>
    회원의 게시물이 정보통신망 이용촉진 및 정보보호 등에 관한 법률 및 저작권법 등 관련법에 위반되는 내용을 포함함으로 인하여, 지식재산권 등의 권리를 보유한 자가 회사에게 관련법이 정한 절차에 따라 해당 게시물의 게시중단 또는 삭제 등을 요청하는 경우, 회사는 관련법에 따라 조치를 취합니다.
    회사는 전항에 따른 권리자의 요청이 없는 경우라도 회사 또는 제3자의 권리침해가 인정될 만한 사유가 있거나 기타 회사 정책 및 관련법에 위반되는 경우에는 관련법에 따라 해당 게시물에 대해 임시조치 등을 취할 수 있습니다.

  </span>
  <strong>제 13 조 (서비스 이용제한) </strong>
  <span>
    회사는 이용자가 이 약관의 의무를 위반하거나 서비스의 정상적인 운영을 방해한 경우, 경고, 일시정지, 영구이용정지, 회원계약 해지 등으로 서비스 이용을 단계적으로 제한할 수 있습니다. 
    회사는 전항에도 불구하고, 이용자가 주민등록법을 위반한 명의도용 및 결제도용, 전화번호 도용, 저작권법 및 컴퓨터프로그램보호법을 위반한 불법프로그램의 제공 및 서비스 운영방해, 정보통신망 이용촉진 및 정보보호 등에 관한 법률을 위반한 불법통신 및 해킹, 악성프로그램의 배포, 접속권한 초과행위 등과 같이 관련법을 위반한 경우에는 즉시 영구이용정지를 할 수 있습니다.
    제1항 또는 제2항에 따른 영구이용정지시 할인 쿠폰 등 서비스 이용과 관련한 이용자의 일체 혜택은 전부 소멸되고, 회사는 그 소멸된 혜택에 대하여 별도로 보상하지 않습니다. 
    회사가 이용자의 서비스 이용을 제한하는 경우에는 회사는 서비스 이용제한의 사유와 이용제한의 내용을 명시하여 이용제한 30일 전 제4조(이용자에 대한 통지)에 따라 통지합니다. 
    회원은 이용제한의 통지를 받은 때로부터 2주 이내에 제1항 또는 제2항에 따른 이용제한 등에 대하여 회사에 따라 이의신청을 할 수 있습니다. 회사는 이용자의 이의가 정당하다고 판단되는 경우 즉시 이용자에 대한 서비스 이용제한을 해제합니다.

  </span>
</div>
</section>
<section>
<h5>[제 4 장 구매계약]</h5>
<div class="trm-inner">
  <strong>제 14 조 (구매신청) </strong>
  <span>
    이용자는 서비스 상에서 다음 또는 이와 유사한 방법에 의하여 구매를 신청하며, 회사는 이용자가 구매신청을 함에 있어서 다음의 각 내용을 알기 쉽게 제공하여야 합니다.
    재화 등의 검색 및 선택
    받는 사람의 성명, 주소, 전화번호, 전자우편주소(또는 전화번호) 등의 입력
    약관 내용, 계약취소· 변경· 환불의 제한, 미성년자의 투숙 조건, 추가 발생 비용 항목 등의 게시
    이 약관에 동의하고 위 3. 호의 사항을 확인하거나 거부하는 표시
    재화 등의 구매신청 및 이에 관한 확인 또는 회사의 확인에 대한 동의
    결제방법의 선택
  </span>
  <br />
  <strong> 제 15 조 (구매계약의 성립) </strong>
  <span>
    이용자는 이 약관 및 기타 규정에 따라 다음 각 호의 절차를 거쳐 구매계약을 체결할 수 있습니다. <br/>
    성명, 연락처의 입력<br/>
    재화 또는 용역 및 이용시간 선택<br/>
    아래 계약조건, 약관 내용, 서비스 내용(포함사항 및 불포함사항), 추가 비용 부담 등의 게시<br/>
      ① 계약취소, 변경 및 환불 불가 상품 고지<br/>
      ② 보호자 동반 시 미성년자 투숙 가능 내용 고지<br/>
      ③ 기타 서비스 관련 내용<br/>
    이용자의 동의(계약체결) 표시<br/>
    결제방법의 선택 및 결제<br/>
    이용자가 제1항 상의 절차에 따라 구매계약 체결 확인란에 동의(예약체결)를 표시하고 재화 또는 물품 구입대금을 결제한 경우, 회사는 이용자가 이 약관 및 서비스 내용을 모두 읽고 이를 충분히 이해하였으며, 이를 적용하는 것에 동의한 것으로 간주합니다.
    이용자의 숙박시설 및 음식점 이용과 관련한 일체의 권리 및 의무는 숙박시설 및 음식점에 귀속되므로, 회사는 이용자의 숙박시설 및 음식점 이용과 관련하여 이용자에게 발생하는 재산적·비재산적 손해 일체에 관하여 어떠한 책임도 부담하지 아니합니다.
    회사는 이용자의 구매계약에 있어 필요로 하는 각종 서비스를 제공하고 회사의 내부정책에 따라 그에 대한 이용료(서비스이용료)를 부과할 수 있습니다.

  </span>
  <strong>제 16 조 (구매계약 기록의 보관) </strong>
  <span>
    구매계약의 거래기록은 전자상거래 등에서의 소비자보호에 관한 법률에 의하여 일정기간 보존합니다.
  </span>
  <strong> 제 17 조 (구매계약의 결제 수단) </strong>
  <span>
    이용자는 회사에서 구매한 재화 또는 용역에 대한 대금지급을 다음 각 호의 방법 중 가용한 방법으로 할 수 있습니다. 단, 회사는 이용자의 지급방법 선택과 관련 없이 어떠한 명목의 수수료도 징수하지 아니합니다.<br/>

    폰뱅킹, 인터넷뱅킹, 메일 뱅킹 등의 각종 계좌이체<br/>
    신용카드, 직불카드, 선불카드 등의 각종 카드<br/>
    회사와 계약을 맺었거나 회사가 인정한 상품권<br/>
    할인쿠폰<br/>
    기타 전자적 지급 방법

  </span>
  <strong>제 18 조 (구매계약의 취소와 환불) </strong>
  <span>
    회사는 구매계약의 취소 및 환불과 관련하여 전자상거래 등의 소비자보호에 관한 법률 등 관련법을 준수합니다. <br/>
    구매계약시 재화 또는 용역의 성격에 따라 회사는 별도의 취소 및 환불 관련 규정을 정할 수 있으며, 회사는 이러한 경우 개별 취소 및 환불 규정을 적용할 수 있습니다.<br/>
    회사는 사업자의 확인 후 이용자의 구매계약의 취소 및 환불 신청을 처리하며, 회사 및 판매자의 취소 및 환불 규정에 따라 취소수수료가 발생할 수 있습니다.<br/>
    구매 취소 시점과 결제수단별 환불 처리기준에 따라 취소금액의 환급 방법과 환급일은 다소 차이가 있을 수 있습니다.<br/>
    회사는 선량한 이용자의 보호를 위하여 다음에 해당하는 고객에 대하여 일정한 기간을 정하여 예약제한 또는 해당 예약 건에 대한 예약취소 조치를 취할 수 있습니다.<br/>
    부정한 방법을 통한 예약의 경우 (예: 매크로 등을 사용한 예약 시도)<br/>
    반복적으로 다량의 재화 또는 용역을 구매 후 취소하는 경우(예: 재판매를 목적으로 한 구매 후 취소)<br/>
    기타 이에 준하는 부정한 이용으로 판단되는 경우<br/>
    미성년자 또는 미성년자의 법정대리인은 계약에 동의하지 아니할 경우 미성년자의 구매를 취소할 수 있으나, 미성년자가 속임수로써 회사로 하여금 법정대리인의 동의가 있는 것으로 믿게 한 경우에는 그 취소가 제한됩니다.
    회원이 예약상품을 구매하는 경우 대금결제는 예약과 동시에 이루어집니다. 만일, 일반예약 상품의 잔여객실 또는 좌석이 없을 경우 결제가 취소되므로 회원에게 별도의 요금이 청구되지 않습니다. 다만, 회원의 사정으로 인하여 예약상품의 결제를 취소하는 경우에는 서비스에 명시된 별도의 특별약관에서 정한 바에 따릅니다.
    기타 이 약관 및 서비스의 이용안내에 규정되지 않은 취소 및 환불에 대한 사항에 대해서는 소비자기본법 등 관련법에서 정한 바에 따릅니다.

  </span>
</div>
</section>
<section>
<h5>[제 5 장 회사와 이용자의 의무]</h5>
<div class="trm-inner">
  <strong>제 19 조(회사의 의무)</strong>
  <span>
    회사는 법령과 이 약관이 금지하거나 공서양속에 반하는 행위를 하지 않으며 이 약관이 정하는 바에 따라 지속적이고, 안정적으로 재화 및 용역을 제공하는데 최선을 다하여야 합니다.
    회사는 이용자가 안전하게 인터넷 서비스를 이용할 수 있도록 이용자의 개인정보(신용정보 포함)보호를 위한 보안 시스템을 갖추어야 합니다.
    회사가 상품이나 용역에 대하여 표시·광고의 공정화에 관한 법률 제3조 소정의 부당한 표시·광고행위를 함으로써 이용자가 손해를 입은 때에는 이를 배상할 책임을 집니다.
    회사는 이용자가 동의하지 않은 영리목적의 광고성 전자우편을 발송하지 않습니다.

  </span>
  <strong> 제 20 조 (이용자의 의무) </strong>
  <span>
    이용자는 서비스 이용에 필요한 전자우편주소, 비밀번호, 결제수단에 관한 정보 등의 관리책임을 부담하며, 서비스의 이용과 관련하여 위 정보를 제3자가 사용하도록 하여서는 아니됩니다.<br/>
    이용자는 관계법령, 이 약관의 규정, 서비스 이용안내 등 회사가 고지하는 사항을 준수하여야 하며, 기타 회사 업무를 방해하거나 저해하는 행위를 하여서는 안됩니다. <br/>
    이용자는 다음 각 호의 행위를 하여서는 안됩니다. <br/>
    서비스 신청 또는 변경 시 허위내용의 등록행위<br/>
    타인의 정보 도용 행위<br/>
    회사가 정한 정보 이외의 정보(컴퓨터 프로그램 등)의 송신 또는 게시행위<br/>
    회사 기타 제3자의 저작권 등 지식재산권 침해행위<br/>
    회사 기타 제3자의 명예 ·신용 훼손 또는 업무방해행위<br/>
    외설 또는 폭력적인 메시지, 화상, 음성 기타 공서양속에 반하는 정보를 공개하거나 게시하는 행위<br/>
    회사의 동의 없이 영리를 목적으로 서비스를 사용하는 행위<br/>
    가공행위를 통하여 서비스를 복제, 분해 또는 모방 기타 변형하는 행위<br/>
    자동 접속 프로그램(매크로) 등에 의하여 비정상적인 방법으로 서비스를 이용하여 회사의 업무 및 서비스제공을 방해하는 행위<br/>
    할인쿠폰을 제3자에게 처분하거나 제3자로부터 양수하는 행위.<br/>
    회사가 이용자를 위해 시행하는 각종의 이벤트 서비스를 회사 서비스정책에 맞지 않도록 사용하는 행위<br/>
    회사의 서비스 이용 과정(서비스에 대한 이의 제기 과정을 포함)에서 회사의 임· 직원(시간제근로자 및 파견근로자 포함)에 대하여 폭행, 협박, 위력 행사, 명예훼손, 모욕, 성추행(언어에 의한 것을 포함) 등 심히 부당한 대우를 하는 행위
    이용자는 회사에서 공식적으로 인정한 경우를 제외하고는 서비스 이용을 통하여 영리를 추구할 수 없으며, 회사의 정보통신설비에 대한 해킹, 광고· 음란정보(음란사이트의 링크를 포함) 등의 게시 행위, 음원· 동영상· 소프트웨어 무단 배포 등의 지식재산권침해 행위를 할 수 없습니다.
    기타 관계 법령이나 회사에서 정한 규정에 위배되는 경우<br/>

    이용자가 위 의무를 위반함으로 인하여 회사 또는 제3자에게 재산적· 비재산적 손해가 발생한 경우 회사는 그로 인하여 발생한 손해로부터 면책되고, 해당 이용자에 대하여 민사상 손해배상의 청구, 형사 고발, 행정기관에 대한 신고 등 일체의 법적 조치를 취할 수 있습니다. 

  </span>
</div>
</section>
<section>
<h5>[제 6 장 기타]</h5>
<div class="trm-inner">
  <span>
    회사는 천재지변 또는 이에 준하는 불가항력으로 인하여 서비스를 제공할 수 없는 경우에는 서비스 제공에 관한 책임이 면제됩니다. <br/>
    회사는 이용자의 귀책사유로 인한 서비스 이용의 장애에 대하여는 책임을 지지 않습니다. <br/>
    회사는 이용자가 게재한 이용후기, 업소 평가 등 정보/자료/사실의 신뢰도, 정확성에 대해서는 책임을 지지 않습니다. <br/>
    회사는 회사의 서비스를 이용하지 않고 이용자와 제휴업주가 직접거래를 한 경우 발생하는 피해에 대하여 책임을 지지 않습니다. <br/>
    회사는 무료로 제공되는 서비스 이용과 관련하여 관련법에 특별한 규정이 없는 한 책임을 지지 않습니다. <br/>
    회사는 이용자가 자신의 개인정보를 타인에게 유출하거나 제공하여 발생하는 피해에 대하여 책임을 지지 않습니다.<br/>
    회사 및 회사의 임직원 그리고 대리인의 고의 또는 중대한 과실이 없는 한 다음과 같은 사항으로부터 발생하는 손해에 대해 책임을 지지 아니합니다. <br/>
    이용자가 회사에 제공한 정보의 허위 또는 부정확성에 기인하는 손해<br/>
    서비스에 대한 접속 및 서비스의 이용과정에서 발생하는 개인적인 손해<br/>
    서버에 대한 제3자의 모든 불법적인 접속 또는 서버의 불법적인 이용으로부터 발생하는 손해<br/>
    서버에 대한 전송 또는 서버로부터의 전송에 대한 제3자의 모든 불법적인 방해 또는 중단행위로부터 발생하는 손해<br/>
    제3자가 서비스를 이용하여 불법적으로 전송, 유포하거나 또는 전송, 유포되도록 한 모든 바이러스, 스파이웨어 및 기타 악성 프로그램으로 인한 손해<br/>
    전송된 데이터의 오류 및 생략, 누락, 파괴 등으로 발생되는 손해<br/>
    회원 간의 이용자 정보 등록 및 서비스 이용 과정에서 발생하는 명예훼손 기타 불법행위로 인한 각종 민형사상 책임<br/>
    회사는 이용자가 서비스를 이용하여 기대하는 수익을 상실한 것에 대하여 책임을 지지 않으며, 그 밖의 서비스를 통하여 얻은 자료로 인한 손해에 관하여 책임을 지지 않습니다. <br/>
    회사는 보호자가 동반하지 않은 미성년자의 숙박시설 이용으로 발생하는 숙박시설로부터의 입실거부, 예약취소, 환불불가 등의 불이익에 관하여 책임지지 않습니다.

  </span>
  <strong> 제 21 조 (연결서비스와 피연결서비스 간의 관계) </strong>
  <span>
    상위 서비스와 하위 서비스가 하이퍼링크 (예: 하이퍼 링크의 대상에는 문자, 그림 및 동영상 등이 포함됨) 방식 등으로 연결된 경우, 전자를 연결서비스라고 하고 후자를 피연결서비스라고 합니다. <br/>
    .연결서비스는 피연결서비스가 독자적으로 제공하는 재화 등에 의하여 회원과 행하는 거래에 대하여 책임을 지지 않습니다. 
    
  </span>
  <strong> 제 22 조 (준거법 및 중재조항) </strong>
  <span>
    회사와 이용자 간에 제기된 전자상거래 분쟁에는 대한민국 법을 적용합니다.
    회사와 이용자 간에 서비스 이용과 직·간접적으로 관련한 이 계약과 관련하여 당사자간에 발생하는 모든 분쟁은 회사의 관할지방법원에서 최종적으로 해결합니다.

  </span>
</div>
</section>
<strong> [부칙] </strong>
<strong>제 1 조 (시행일)</strong>
<strong
>이 약관은 <span class="font-red">2023.12.01</span> 부터
시행됩니다.</strong
>

`;

const U01EN = `
<section> 
  <h5>[Chapter 1: General Provisions]</h5>
  <div class="trm-inner">
  <strong>Article 1 (Purpose)</strong>
  <span>
    The purpose of these Terms and Conditions is to define the rights, duties, and responsibilities of the Company—UBI Company, Ltd. (hereinafter referred to as "the Company")—and the Users (individuals or legal entities), as well as the conditions, procedures, and other necessary matters concerning the use of all e‑commerce–related services provided by the Company. These Terms govern all such services offered by the Company.
  </span>
  <strong>Article 2 (Definitions)</strong>
  <span>
    <p>Unless otherwise defined herein, the terms used in these Terms shall have the following meanings:</p>
    “Service” refers to all electronic services provided by the Company, including lodging brokerage and other offerings, and encompasses services delivered to Users via third‑party platforms developed or built using the Company's publicly available APIs (Application Programming Interfaces).<br/>
    “User” means either a Member or a Non-member who uses the services provided by the Company.<br/>
    “Member” means a person who has entered into a membership agreement with the Company under these Terms and uses the Services provided by the Company.<br/>
    “Non‑member” means a person who uses the Services without entering into a membership agreement as defined in these Terms.<br/>
    “Applicant” means a person who intends to become a Member under these Terms.<br/>
    “Membership Agreement” means the agreement concluded between the Company and the Applicant for membership, and “Purchase Agreement” means the contract for sale of goods or services between the Company and the User.<br/>
    “Password” refers to the combination of letters and numbers uniquely chosen by the Member and registered with the Company for the purpose of user authentication.<br/>
    “Discount Coupon” refers to a digital voucher that entitles the User to receive a discount equivalent to the face value printed on the voucher when purchasing tickets or products.<br/>
    “Seller” means any business entity (individual or legal entity) that uses the Services provided by the Company to present information on goods or services to Users and who sells those goods or services.
  </span>
  <strong>Article 3 (Posting, Explanation, and Amendment of Terms)</strong>
  <span>
    The Company shall display these Terms along with its name, representative’s name, address of business location, telephone number, email address, business registration number, and other necessary information on its website (service homepage). However, the Terms may also be made available to Users via a linked page.<br/>
    The Company may amend these Terms to the extent that such amendments do not violate applicable laws such as the Act on the Consumer Protection in Electronic Commerce, Regulation of Terms and Conditions Act, Basic Act on Electronic Documents and Electronic Transactions, Electronic Financial Transactions Act, Digital Signature Act, Act on Promotion of Information and Communications Network Utilization and Information Protection, Consumer Basic Act, and related statutes.<br/>
    When amending the Terms, the Company shall post the current Terms and the revised Terms—including the effective date and reasons for revision—on the service homepage from at least seven days prior to and until the date before the effective date. However, if the amendment disadvantages the Users, the Company must notify Users not only via the service homepage at least 30 days before the effective date, but also through electronic means such as written notice (including electronic documents or email) or pop-ups upon service access.<br/>
    Unless otherwise required by law or due to unavoidable circumstances, amended Terms shall apply only to agreements concluded after the effective date. Agreements already in place prior to such date shall remain governed by the prior version of the Terms.<br/>
    If the Company notifies Users that failure to express dissent within the specified period will be deemed as consent, and the User does not explicitly object, the User shall be considered to have agreed to the amended Terms. Should a User not agree to the amendments, the User may terminate the membership agreement at any time.<br/>
    Matters not stipulated in these Terms or the interpretation thereof shall be governed by applicable laws such as the Act on the Consumer Protection in Electronic Commerce and the Regulation of Terms and Conditions Act, or by customary commercial practice.
  </span>
  <strong>Article 4 (Notices to Users)</strong>
  <span>
    Unless otherwise specified in these Terms, notices to Users shall be made in writing (including electronic documents or email) to the email address, telephone number, or address provided by the User to the Company.<br/>
    Notices to all Users may be made by posting on the Company’s “Notices” (support center) for a period of no less than seven days, which shall be deemed equivalent to individual notice. However, matters that significantly impact individual Users' use of the Service shall be notified separately.
  </span>
</div>
</section>

<section>
<h5>[Chapter 2: Formation and Termination of Membership Agreements]</h5>
<div class="trm-inner">
  <strong>Article 5 (Formation of Membership Agreements)</strong>
  <span>
    A Membership Agreement is formed when an Applicant agrees to the Terms, submits a membership application, and the Company accepts that application. If the Applicant is under 14 years old, the Company presumes that the minor’s legal representative has read, fully understood, and agreed to the Terms by checking the consent box provided at the time of application.<br/>
    The Company may require the Applicant to undergo identity verification or authentication through a specialized agency.<br/>
    The Applicant must provide the required personal information such as name, date of birth, gender, email address, password, telephone number, and address upon the Company’s request.<br/>
    The Company generally approves service use applications, but may refuse or later terminate a Membership Agreement if the Applicant:<br/>
    • Does not use their real name or uses another person’s name;<br/>
    • Previously lost membership under these Terms (unless re‑admission is approved by the Company);<br/>
    • Provides false information or omits required information;<br/>
    • Is under 19 without legal representative consent;<br/>
    • Re-applies within 30 days of withdrawing membership or uses the Service for improper or commercial purposes;<br/>
    • Applies for purposes contrary to laws or public order;<br/>
    • Violates other requirements due to the Applicant’s fault;<br/>
    • Or if the Company’s service facilities are insufficient or technical/operational issues exist, approval may be delayed or withheld.<br/>
    If the Company refuses to accept or defers approval of the application, it shall inform the Applicant accordingly.<br/>
    The timing of the Membership Agreement’s formation is when the Company notifies the Applicant of its acceptance (membership confirmation).
  </span>
  <strong>Article 6 (Termination of Membership Agreements)</strong>
  <span>
    Members may apply for termination of the Membership Agreement at any time, and the Company shall process it within three business days in accordance with applicable laws.<br/>
    If grounds for violation of the Membership Agreement arise, the Company may issue a written (including electronic documents or email) notice giving the Member at least two weeks to cure the violation. If the violation is not corrected within that period, the Company may terminate the Membership Agreement by expressing its intent to do so. However, if circumstances prevent the Member from continuing to exercise rights or duties under the Agreement, the Company may terminate it without prior notice.<br/>
    Such grounds include, but are not limited to,<br/>
    • Occurrence of grounds specified in Article 5, paragraph 4;<br/>
    • Causing direct or indirect property or non‑property damage to the Company or third parties;<br/>
    • Infringing rights, reputation, or credit of the Company or others, thereby harming Company business;<br/>
    • Acts violating these Terms or other termination grounds.<br/>
    When either party terminates the Membership Agreement, the Company shall process the withdrawal within three business days of notification.<br/>
    Unless otherwise permitted by law or the Company's privacy policy, all Member data shall be destroyed immediately upon completion of withdrawal procedures:<br/>
    • **Destruction procedure**: The Company selects personal information to be destroyed, obtains approval from the person in charge of personal information protection, and proceeds with destruction.<br/>
    • **Destruction method**: Electronic files are irreversibly deleted, and paper documents are shredded or incinerated.<br/>
    Upon termination, any unused discount coupons held by the Member expire immediately, and the Member cannot claim legal compensation for any loss of economic benefit caused by their expiration.<br/>
    The termination date of the Membership Agreement is the date on which the Company notifies the Member of the termination.
  </span>
</div>
</section>

<section>
<h5>[Chapter 3: Use of the Service]</h5>
<div class="trm-inner">
  <strong>Article 7 (Provision and Modification of the Service)</strong>
  <span>
    The Company offers the following services to Members:<br/>
    • Information about lodging facilities, restaurants, and other venues;<br/>
    • Reservation services for lodging and restaurants;<br/>
    • Additional services developed by the Company or provided through partnerships.<br/>
    If there are significant reasons such as a decline in usage, difficulty in service provision, reduced profitability, or changes in Company policy, the Company may modify or suspend some or all of the Services for operational or technical reasons. The Company shall notify Users at least 30 days in advance on the WCRS homepage (service homepage) of the type, content, reason, and date of any changes or suspension.<br/>
    The Company may modify, suspend, or discontinue free services for business reasons without compensation, unless otherwise required by law.
  </span>
  <strong>Article 8 (Service and Customer Support Availability)</strong>
  <span>
    Services are generally available on weekdays (excluding public holidays) from 9 a.m. to 6 p.m.<br/>
    The Company may temporarily suspend services due to maintenance, replacement or failure of IT equipment, communication disruptions, or significant operational reasons, and shall notify Members following the method in Article 4. If prior notification is not possible, the Company may notify after the fact.<br/>
    The Company may perform scheduled maintenance as necessary, with the schedule posted on the service homepage.
  </span>
  <strong>Article 9 (Provision of Information and Display of Advertisements)</strong>
  <span>
    The Company may provide information deemed necessary for service use via notices, written communication (including electronic documents or email), SMS, telephone, or app push notifications. Members may refuse receipt of such information at any time, except for transaction-related information or responses to inquiries as required by law.<br/>
    The Company may display advertisements on the website, via email, SMS, or app push. For electronic transmission methods such as email, SMS, or app push, the Company must obtain the recipient’s explicit prior consent under the Information and Communications Network Act. If a Member indicates refusal of reception or withdraws prior consent, the Company shall not send any commercial advertising. Members who receive advertising by email may opt out by notifying the Company.
  </span>
  <strong>Article 10 (Service Use and Intellectual Property Rights)</strong>
  <span>
    All intellectual property rights in works created or edited by the Company (including derivative works) are owned by the Company. Users must not reproduce, transmit, publish, distribute, broadcast, or allow third parties to use such works without the Company’s explicit prior consent.<br/>
    Copyright in any “Posts” (such as text, photos, video, files, links) posted by Members remains with the Member. Upon signing up and using the Wings Booking service, the Company may display the Member’s Posts on the service interface in compliance with copyright law; Members may request deletion or privacy control through customer support or in-app management tools at any time.<br/>
    Even without a rights holder’s specific request, the Company may take temporary action against any Post reasonably viewed as infringing rights or violating Company policy or laws. To promote constructive community engagement, the Company may partially redact or anonymize sensitive personal information in Posts without consent. All rights and responsibilities regarding Posts belong to the Member; voluntary disclosure of information may reduce its protection, so Users should consider carefully before posting. Posts are automatically deleted upon withdrawal.
  </span>
  <strong>Article 11 (Management of Posts)</strong>
  <span>
    If a Member’s Post violates laws such as the Information and Communications Network Act or copyright law, and a rights holder requests removal via the legally required process, the Company shall take appropriate action. The Company may also take interim action against Posts not subject to such a request if there are reasonable grounds to believe rights infringement or other legal/policy violations are occurring.
  </span>
  <strong>Article 12 (Discount Coupons)</strong>
  <span>
    Discount Coupons are subject to the provisions regarding Posts as set forth in both Articles 10 and 11.
  </span>
  <strong>Article 13 (Restrictions on Service Use)</strong>
  <span>
    If a User violates these Terms or interferes with normal service operation, the Company may impose penalties such as warnings, temporary suspension, permanent suspension, or termination of the Membership Agreement in stages.<br/>
    Notwithstanding the foregoing, in cases of serious violations—such as identity fraud via violation of the Resident Registration Act, unauthorized use of payment or phone number, provision of illegal programs in violation of copyright or the Protection of Computer Programs Act, illegal communication, hacking, malware distribution, or unauthorized access—the Company may permanently suspend service immediately. All benefits, including discount coupons, expire upon permanent suspension, and the Company shall offer no compensation.<br/>
    The Company shall notify the User of the reason and content of service restriction at least 30 days in advance according to Article 4. The User may raise objections within two weeks of notification. If the Company deems the objection valid, it shall promptly reinstate service access.
  </span>
</div>
</section>

<section>
<h5>[Chapter 4: Purchase Agreement]</h5>
<div class="trm-inner">
  <strong>Article 14 (Purchase Request)</strong>
  <span>
    Users may request a purchase through the Service using the following or similar methods, and the Company shall clearly provide the following information to the User during the purchase request process:
    - Search and selection of goods or services
    - Input of recipient’s name, address, phone number, email address (or phone number), etc.
    - Display of terms and conditions, restrictions on cancellation, changes, and refunds, conditions for minors’ stays, and additional costs
    - Indication of agreement to these Terms and confirmation or rejection of the above items
    - Request for purchase and confirmation thereof, or confirmation of the Company’s acceptance
    - Selection of payment method
  </span>
  <br />
  <strong>Article 15 (Formation of the Purchase Agreement)</strong>
  <span>
    Users may enter into a Purchase Agreement by following the procedures specified in these Terms and other related regulations:<br/>
    - Enter name and contact information<br/>
    - Select goods/services and usage time<br/>
    - Display of the following details: contract conditions, terms of service (inclusions and exclusions), any additional charges<br/>
      ① Notice of non-cancellable, non-refundable products<br/>
      ② Notification that minors may stay when accompanied by a guardian<br/>
      ③ Other service-related details<br/>
    - User’s indication of consent (contract agreement)<br/>
    - Selection and completion of payment method<br/><br/>
    When a User consents to the agreement in the confirmation section and completes the payment, the Company shall deem the User to have read, fully understood, and agreed to these Terms and the service content.<br/>
    All rights and obligations related to the use of accommodations and restaurants belong to the respective providers. The Company is not liable for any property or non-property damages incurred by the User in connection with such services.<br/>
    The Company may provide necessary services related to the User’s purchase and may charge a usage fee in accordance with its internal policy.
  </span>

  <strong>Article 16 (Retention of Purchase Records)</strong>
  <span>
    Records of Purchase Agreements shall be retained for a designated period in accordance with applicable laws, including the Act on Consumer Protection in Electronic Commerce.
  </span>

  <strong>Article 17 (Payment Methods)</strong>
  <span>
    Users may pay for goods or services purchased through the Company using one of the following available methods. The Company shall not charge any fees regardless of the User's selected payment method:<br/>
    - Bank transfers via phone banking, internet banking, or email banking<br/>
    - Various cards including credit cards, debit cards, and prepaid cards<br/>
    - Gift certificates issued or recognized by the Company<br/>
    - Discount coupons<br/>
    - Other electronic payment methods
  </span>

  <strong>Article 18 (Cancellation and Refund of Purchase Agreement)</strong>
  <span>
    The Company complies with applicable laws including the Act on Consumer Protection in Electronic Commerce regarding cancellations and refunds.<br/>
    Depending on the nature of the goods or services, the Company may set separate cancellation and refund policies and apply them accordingly.<br/>
    The Company processes cancellation and refund requests after confirmation by the relevant provider, and cancellation fees may apply based on Company and Seller policies.<br/>
    The timing of cancellation and the refund method may vary depending on the payment method and time of request.<br/>
    To protect legitimate Users, the Company may temporarily restrict bookings or cancel specific reservations for the following:<br/>
    - Reservations made using fraudulent methods (e.g., use of macros)<br/>
    - Repeated large-volume purchases followed by cancellations (e.g., resale purposes)<br/>
    - Any other fraudulent use deemed similar<br/>
    Minors or their legal guardians may cancel a purchase if consent was not given, but if the minor intentionally deceived the Company into believing consent was obtained, cancellation may be restricted.<br/>
    When a Member purchases a reservation product, payment is made at the time of reservation. If no availabil

  </span>
  </div>
</section>
  `;
